import { KnowledgeInputFragment } from '@/generated/graphql';
import { RcFile } from 'antd/es/upload';
import axios, {
  AxiosError,
  AxiosHeaders,
  AxiosResponse,
  RawAxiosRequestConfig,
  RawAxiosRequestHeaders,
} from 'axios';
import { dev } from '../../apollo/ApolloSetup';
import { proxy_buildDocumentUploadUrl } from './document-url-helper';
import { DocumentReference } from './types';

interface DocumentUploadSuccess {
  id?: string;
  groupId?: string;
}

export const proxy_uploadDocument = (
  clinicId: string,
  content: string | Blob | RcFile,
  uploadReference: DocumentReference,
  documentClass?: KnowledgeInputFragment, // optional
  callbacks?: {
    onSuccess?: (response: AxiosResponse<DocumentUploadSuccess, unknown>) => void;
    onError?: (error: any) => void;
    onVirusFound?: () => void;
  },
) => {
  const headers: RawAxiosRequestHeaders | AxiosHeaders = {
    'content-type': 'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
  };
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : undefined;

  // In production the auth is done using cookies
  if (dev && token) {
    // @ts-ignore
    headers['authorization'] = `Bearer ${token}`;
  }

  const config: RawAxiosRequestConfig = {
    withCredentials: !dev,
    headers,
  };

  const uploadUrl = proxy_buildDocumentUploadUrl(clinicId, uploadReference, documentClass);

  if (!uploadUrl) {
    console.error('Upload url could not be constructed.');
    return;
  }

  const data = new FormData();
  data.append('content', content);

  axios
    .post(uploadUrl.toString(), data, config)
    .then((response: AxiosResponse<DocumentUploadSuccess, unknown>) => {
      if (response.status === 200) {
        callbacks?.onSuccess?.(response);
      } else {
        callbacks?.onError?.(null);
      }
    })
    .catch((error: AxiosError) => {
      if (error?.response?.headers?.['x-avelios-block-reason'] === 'VIRUS_FOUND' && error?.status === 403) {
        callbacks?.onVirusFound?.();
      } else {
        callbacks?.onError?.(error);
      }
    });
};

export const bytesToMB = (bytes: number): string => {
  return (bytes / (1024 * 1024)).toFixed(2); // Convert and round to 2 decimal places
};
